import { Rule } from "@fairfleet/geotab";
import { GridColumnHeaders } from "@mui/x-data-grid-pro";
import React from "react";
import { useTranslation } from "react-i18next";
import { I18nGrid } from "@/components/data/I18nGrid";
import { NameCell } from "@/components/grid/cells/NameCell";

interface Props {
  isLoading: boolean;
  data?: Rule[];
  setSelectedIds?: React.Dispatch<React.SetStateAction<string[]>>;
}

export function RulesGrid({ data = [], isLoading, setSelectedIds }: Props) {
  const { t } = useTranslation();

  return (
    <I18nGrid
      settingsKey="adminRules"
      rows={data}
      slots={{
        columnHeaders: GridColumnHeaders,
      }}
      slotProps={{
        loadingOverlay: {
          variant: "linear-progress",
          noRowsVariant: "skeleton",
        },
      }}
      columns={[
        {
          flex: 1,
          minWidth: 200,
          field: "name",
          headerName: t("diagnosticEdit.name", "Name"),
          renderCell: NameCell,
        },
        {
          flex: 1,
          minWidth: 200,
          field: "comment",
          headerName: "Comment",
          renderCell: NameCell,
        },
      ]}
      loading={isLoading}
      checkboxSelection={!!setSelectedIds}
      onRowSelectionModelChange={setSelectedIds ? ids => setSelectedIds(ids as string[]) : undefined}
    />
  );
}
